export default "images/product.png";